export const readFreshCache = (key, maxAgeMs) => {
  if (typeof window === "undefined" || !key || maxAgeMs <= 0) return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const savedAt = Number(parsed?.savedAt);
    if (!Number.isFinite(savedAt) || Date.now() - savedAt > maxAgeMs) {
      window.localStorage.removeItem(key);
      return null;
    }
    return parsed?.value ?? null;
  } catch {
    return null;
  }
};

export const writeCache = (key, value) => {
  if (typeof window === "undefined" || !key) return;
  try {
    window.localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), value }));
  } catch {
    // Storage can be unavailable in private mode or when its quota is full.
  }
};
